module.exports = __webpack_public_path__ + "img/wanasaImage.6b3be0f0.png";